import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { range } from 'lodash';
import MySelect from '@/components/MySelect.vue';
let CharacterBuilderClassHitPoints = class CharacterBuilderClassHitPoints extends Vue {
    constructor() {
        super(...arguments);
        this.range = range;
    }
    get maxValue() {
        return this.classData.hitPointsAtFirstLevelNumber + 1;
    }
    get hitPointsMap() {
        return range(1, this.myClass.levels + 1).map(level => {
            const hpIndex = this.isStartingClass ? level - 2 : level - 1;
            const hitPoints = hpIndex < 0 ? this.classData.hitPointsAtFirstLevelNumber : this.myClass.hitPoints[hpIndex];
            return { hpIndex, hitPoints };
        });
    }
    handleUpdate(newValue, hpIndex) {
        this.$emit('updateHitPoints', { newValue, hpIndex });
    }
};
__decorate([
    Prop(Object)
], CharacterBuilderClassHitPoints.prototype, "classData", void 0);
__decorate([
    Prop(Object)
], CharacterBuilderClassHitPoints.prototype, "myClass", void 0);
__decorate([
    Prop(Boolean)
], CharacterBuilderClassHitPoints.prototype, "isStartingClass", void 0);
CharacterBuilderClassHitPoints = __decorate([
    Component({
        components: {
            MySelect
        }
    })
], CharacterBuilderClassHitPoints);
export default CharacterBuilderClassHitPoints;
